module.exports = __webpack_public_path__ + "static/media/Add.f1f9ae5d.svg";